/**
 * @name 헤더
 * @description
 */
import {DropDown, Flex, IconTextButton, Text, useRoutes} from 'lib'
import {useEffect} from 'react'
import styled from 'styled-components'
import {COLOR} from 'styles'
// contents

export default function Contents() {
  // hooks
  const {navigate} = useRoutes()
  //*--------------------------------------------------*
  useEffect(() => {}, [])
  //*--------------------------------------------------*
  return (
    <Content>
      <Flex alignitems="center">
        <Text mode="Headline_MB" color={COLOR.gray30} style={{marginRight: 16}}>
          용해로 알림 설정
        </Text>
      </Flex>
      {/* 유틸메뉴 */}
    </Content>
  )
}
//*--------------------------------------------------*
const Content = styled.div`
  display: flex;
  width: 100%;
  height: 80px;
  padding: 0 24px;
  border-bottom: 1px solid ${COLOR.gray90};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
